import { render } from "./AttachmentControl.vue?vue&type=template&id=ca1448a0&scoped=true&ts=true"
import script from "./AttachmentControl.vue?vue&type=script&lang=ts"
export * from "./AttachmentControl.vue?vue&type=script&lang=ts"

import "./AttachmentControl.vue?vue&type=style&index=0&id=ca1448a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1448a0"]])

export default __exports__